// ══════════════════════════════════════════════════════════════════════════════
// SELDOR — Theme Constants
// Dark and Light theme definitions
// ══════════════════════════════════════════════════════════════════════════════

export const darkTheme = {
  name: 'dark',
  // Backgrounds
  bg: '#060918',
  bgCard: '#0D1137',
  bgSecondary: '#080B24',
  bgInput: '#141840',
  bgElevated: '#151A3F',
  // Brand colors
  primary: '#00C0A3',
  primaryDim: 'rgba(0, 192, 163, 0.12)',
  primaryBorder: 'rgba(0, 192, 163, 0.25)',
  // Semantic colors
  danger: '#FF4C6A',
  dangerDim: 'rgba(255, 76, 106, 0.12)',
  warning: '#FFB547',
  warningDim: 'rgba(255, 181, 71, 0.12)',
  success: '#00C0A3',
  successDim: 'rgba(0, 192, 163, 0.12)',
  info: '#6C8EFF',
  infoDim: 'rgba(108, 142, 255, 0.12)',
  // Text
  text: '#E8EAF6',
  textSecondary: '#8A8FB5',
  textTertiary: '#5C6190',
  // Borders
  border: 'rgba(255, 255, 255, 0.06)',
  borderLight: 'rgba(255, 255, 255, 0.03)',
  borderStrong: 'rgba(255, 255, 255, 0.12)',
  // Shadows
  shadow: '0 4px 24px rgba(0, 0, 0, 0.4)',
  shadowElevated: '0 12px 48px rgba(0, 0, 0, 0.5)',
  // Chart palette
  chartColors: ['#00C0A3', '#6C8EFF', '#FFB547', '#FF4C6A', '#A78BFA', '#F472B6', '#34D399']
};

export const lightTheme = {
  name: 'light',
  bg: '#F4F5F9',
  bgCard: '#FFFFFF',
  bgSecondary: '#FAFBFE',
  bgInput: '#F0F1F5',
  bgElevated: '#FFFFFF',
  primary: '#00917B',
  primaryDim: 'rgba(0, 145, 123, 0.08)',
  primaryBorder: 'rgba(0, 145, 123, 0.2)',
  danger: '#E53E5C',
  dangerDim: 'rgba(229, 62, 92, 0.08)',
  warning: '#D9960A',
  warningDim: 'rgba(217, 150, 10, 0.08)',
  success: '#00917B',
  successDim: 'rgba(0, 145, 123, 0.08)',
  info: '#4A6AE5',
  infoDim: 'rgba(74, 106, 229, 0.08)',
  text: '#1A1D3B',
  textSecondary: '#6B7094',
  textTertiary: '#9BA0BF',
  border: 'rgba(0, 0, 0, 0.08)',
  borderLight: 'rgba(0, 0, 0, 0.04)',
  borderStrong: 'rgba(0, 0, 0, 0.15)',
  shadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
  shadowElevated: '0 8px 32px rgba(0, 0, 0, 0.1)',
  chartColors: ['#00917B', '#4A6AE5', '#D9960A', '#E53E5C', '#7C5CFC', '#D946A8', '#10B981']
};

export const getTheme = (name) => (name === 'light' ? lightTheme : darkTheme);
